import { Card, H4 } from "@blueprintjs/core";
import React from "react";
import { SKILLSCOM_URL } from "../../utils/routes";
import { LayoutDefault } from "../LayoutDefault";
import MenuSkillsCom from "./MenuSkillsCom";

const styleWrap = {
  display: "grid",
  gap: "20px",
  gridTemplateColumns: "auto 1fr",
  marginTop: "20px",
};

export const LayoutSkillsCom = ({ children }) => {
  return (
    <LayoutDefault>
      <div style={{ ...styleWrap }}>
        <div>
          <MenuSkillsCom />
        </div>

        <Card
          elevation={2}
          style={{ height: "calc(100vh - 90px)", overflow: "auto" }}
        >
          <H4>
            <a href={SKILLSCOM_URL} target="_blank">
              SkillsCom
            </a>
          </H4>
          <div>{children}</div>
        </Card>
      </div>
    </LayoutDefault>
  );
};
